import {
	Component, Input, Output, OnInit, OnChanges, SimpleChanges, OnDestroy,
	 EventEmitter, ChangeDetectorRef, AfterViewInit
} from '@angular/core';


@Component({
	selector: 'ping-history-dialog',
	templateUrl: './pinghistorydialog.component.html',
	styleUrls: ['./pinghistorydialog.component.scss']
})
export class PingHistoryDialogComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

	@Input()
	public visible: boolean;

	@Input()
	public monitorType: string;

	@Input()
	public deviceGuid: string;

	@Input()
	public monitorPolicyGuid: string;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onClose: EventEmitter<any>;
	
	constructor(private changeDetector: ChangeDetectorRef) {

		this.visible = false;
		this.monitorType = "";
		this.deviceGuid = "";
		this.monitorPolicyGuid = "";
		this.visibleChange = new EventEmitter<boolean>();
		this.onClose = new EventEmitter<any>();
	}

	public ngOnInit(): void {

	}

	public ngAfterViewInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {

	}

	public ngOnDestroy(): void {

	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onCloseClicked(): void {
		this.onClose.emit();
		this.hide();
	}

}
